import React, { useState } from "react";
import { Container, Button, Col, Row, Accordion, Card } from "react-bootstrap";
import { FiPlus, FiMinus } from "react-icons/fi";

import { IoArrowForwardOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { FiClock } from "react-icons/fi";
import { PiGraduationCapLight } from "react-icons/pi";

import { Helmet } from "react-helmet-async";

import HomeBanner from "../../assets/publicpageimg/ready-Shape-ur-future.png";

// import Subjectimg1 from "../../assets/publicpageimg/home-mern.png";
// import Subjectimg2 from "../../assets/publicpageimg/home-frontend.png";
// import Subjectimg4 from "../../assets/publicpageimg/home-backend.png";
// import Subjectimg6 from "../../assets/publicpageimg/home-digital.png";
// import Subjectimg3 from "../../assets/publicpageimg/home-uiux.png";
// import Subjectimg5 from "../../assets/publicpageimg/home-data.png";

// old img
// import frontendImg from "../../assets/publicpageimg/frontend-img.png";
// import backnedImg from "../../assets/publicpageimg/backend-img.png";
// import mernImg from "../../assets/publicpageimg/meran-stack-imh.png";


// latest img
import frontendImg from "../../assets/publicpageimg/frontend-course.png";
import backnedImg from "../../assets/publicpageimg/backend-course.png";

import "./Course.css";

const faqsData = [
  {
    question: "What types of courses does Skilledition offer?",
    answer:
      "Skilledition offers practical courses designed to help learners build job-ready skills through structured learning and hands-on projects.",
  },
  {
    question: "Who can enroll in these courses?",
    answer:
      "Our courses are open to students, graduates, working professionals, and anyone looking to learn new skills or advance their career.",
  },
  {
    question: "Do I need prior experience?",
    answer:
      "Not necessarily. Many courses are beginner-friendly, while advanced programs may recommend basic knowledge of the subject.",
  },
  {
    question: "Will I work on real-world projects?",
    answer:
      "Yes. Our courses include hands-on projects and practical assignments that help you apply your knowledge and build a strong portfolio.",
  },
  {
    question: "How will these courses help my career?",
    answer:
      "Our courses focus on practical skills and real-world projects to help you build experience, strengthen your portfolio, and prepare for career opportunities.",
  },
];

const modulesData = [
  {
    id: 1,
    title: "Frontend Development",
    category: "frontend",
    description:
      "Learn HTML, CSS, JavaScript, and React to build responsive, interactive websites through hands-on projects and practical learning.",
    image: frontendImg,
    route: "/frontend-development",
    weeks: "6 - 7",
    whatsappMessage:
      "Hi, I am interested in the Frontend Developer program. I want to know more details.",
  },
  {
    id: 2,
    title: "Backend Development",
    category: "backend",
    description:
      "Learn Node.js, Express.js, MongoDB, and RESTful APIs to build secure backend applications through hands-on projects.",
    image: backnedImg,
    weeks: "4 - 5",
    route: "/backend-development",
    whatsappMessage:
      "Hi, I am interested in the Backend Developer program. Please share more information.",
  },
  // {
  //   id: 3,
  //   title: "MERN Stack Development",
  //   category: "fullstack",
  //   description:
  //     "Master the MERN stack to build full-stack web applications through hands-on, real-world projects.",
  //   image: mernImg,
  //   route: "/mern-stack",
  //   weeks: "11 - 12",
  //   whatsappMessage:
  //     "Hi, I am interested in the MERN Stack Developer course. I would like enrollment details.",
  // },
  // {
  //   id: 4,
  //   title: "Digital Marketing",
  //   category: "marketing",
  //   description: "Grow brands using SEO, Ads, and Social Media strategies.",
  //   image: Subjectimg6,
  //   route: "/digital-marketing",
  //   weeks: "5 - 6",
  //   whatsappMessage:
  //     "Hi, I am interested in the Digital Marketing program. Please guide me further.",
  // },
  // {
  //   id: 5,
  //   title: "UI/UX Designer",
  //   category: "frontend",
  //   description:
  //     "Create intuitive, user-centric interfaces with modern UI/UX tools and workflows.",
  //   image: Subjectimg3,
  //   route: "/uiux-designer",
  //   weeks: "9 - 10",
  //   whatsappMessage:
  //     "Hi, I am interested in the UI/UX Designer program at Skilledition. Please share more details about curriculum, duration, and certification.",
  // },
  // {
  //   id: 6,
  //   title: "Data & Analytics",
  //   category: "backend",
  //   description:
  //     "Transform data into actionable insights with modern analytics tools.",
  //   image: Subjectimg5,
  //   route: "/data-analytics",
  //   weeks: "6 - 8",
  //   whatsappMessage:
  //     "Hi, I am interested in the Data & Analytics program at Skilledition. Please share more details about curriculum, duration, and certification.",
  // },
];

const Course = () => {
  const [activeKey, setActiveKey] = useState("0");
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Skilledition | Courses – Job-Ready Tech & Digital Skills</title>

        <meta
          name="description"
          content="Explore Skilledition courses in MERN stack, digital marketing, and tech skills designed for hands-on learning and career growth."
        />

        <link rel="canonical" href="https://skilledition.in/course" />

        {/* Open Graph / Social Share */}
        <meta
          property="og:title"
          content="Skilledition | Courses – Job-Ready Tech & Digital Skills"
        />
        <meta
          property="og:description"
          content="Industry-focused courses with real projects and expert guidance."
        />
        <meta property="og:url" content="https://skilledition.in/course" />
        <meta
          property="og:image"
          content="https://skilledition.in/seo-banner-courses.png"
        />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Skilledition | Courses – Job-Ready Tech & Digital Skills"
        />
        <meta
          name="twitter:description"
          content="Industry-focused courses with real projects and expert guidance."
        />
        <meta
          name="twitter:image"
          content="https://skilledition.in/seo-banner-courses.png"
        />
      </Helmet>

      <section className="skilledition-Courses-page">
        <Container className="skilledition-Courses-page-container">
          <h2 className="skilledition-Course-title text-center mb-5">
            Discover Our Courses
          </h2>

          <Row>
            {modulesData.map((module, index) => {
              let animationClass = "";

              if (index % 3 === 0)
                animationClass = "slide-left"; // left column
              else if (index % 3 === 1)
                animationClass = "slide-middle"; // middle column
              else animationClass = "slide-right"; // right column

              return (
                <Col
                  lg={4}
                  md={6}
                  className={`mb-4 skilledition-course-animate ${animationClass}`}
                  key={module.id}
                  style={{ animationDelay: `${index * 0.15}s` }} // stagger animation
                >
                  <Card className="skilledition-courses-cards">
                    <div className="skilledition-courses-image-wrapper">
                      <Card.Img
                        src={module.image}
                        className="skilledition-courses-image"
                      />
                    </div>
                    <Card.Body>
                      <Card.Title className="skilledition-courses-title">
                        {module.title}
                      </Card.Title>
                      <Card.Text className="skilledition-courses-text">
                        {module.description}
                      </Card.Text>

                      <div className="skilledition-courses-icons-section">
                        <span className="skilledition-courses-icon-item">
                          <FiClock className="skilledition-courses-icon" />
                          <span>{module.weeks} Weeks</span>
                        </span>
                        <span className="skilledition-courses-icon-item">
                          <PiGraduationCapLight className="skilledition-courses-icon" />
                          <span>Industry Certification</span>
                        </span>
                      </div>

                      <div className="skilledition-courses-two-home-btn">
                        <Button
                          className="skilledition-courses-details-btn"
                          onClick={() => navigate(module.route)}
                        >
                          Details
                        </Button>
                        <Button
                          className="skilledition-courses-btn"
                          // onClick={() =>
                          //   window.open(
                          //     `https://wa.me/918143879627?text=${encodeURIComponent(module.whatsappMessage)}`,
                          //     "_blank",
                          //   )
                          // }
                          onClick={() => navigate("/signin")}
                        >
                          Enroll Now <IoArrowForwardOutline />
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </Container>
      </section>

      <section className="skilledition-faqs-section reveal">
        <Container>
          <Row>
            {/* LEFT CONTENT */}
            <Col lg={5} className="skilledition-faqs-left">
              <h2 className="skilledition-faqs-title">
                Frequently asked <br /> questions.
              </h2>
              <p className="skilledition-faqs-desc">
                Skilledition is designed to answer common questions clearly and
                help learners understand our platform easily.
              </p>
            </Col>

            {/* RIGHT FAQ */}
            <Col lg={7} className="skilledition-faqs-right">
              <Accordion
                activeKey={activeKey}
                className="skilledition-faqs-accordion"
              >
                {faqsData.map((faq, index) => (
                  <Accordion.Item
                    eventKey={index.toString()}
                    key={index}
                    className={`skilledition-faq-item ${
                      activeKey === index.toString() ? "active" : ""
                    }`}
                  >
                    <Accordion.Header
                      onClick={() =>
                        setActiveKey(
                          activeKey === index.toString()
                            ? null
                            : index.toString(),
                        )
                      }
                    >
                      <span className="skilledition-faq-question">
                        {faq.question}
                      </span>

                      <span className="skilledition-faq-icon">
                        {activeKey === index.toString() ? (
                          <FiMinus />
                        ) : (
                          <FiPlus />
                        )}
                      </span>
                    </Accordion.Header>

                    <Accordion.Body className="skilledition-faq-answer">
                      {faq.answer}
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="skilledition-banner-section reveal">
        <Container>
          <div className="skilledition-banner-section-wrapper">
            <div className="skilledition-banner-section-left">
              <h2 className="skilledition-banner-section-title">
                Ready to Shape <br /> Your Future?
              </h2>

              <p className="skilledition-banner-section-text">
                Start learning practical skills through expert-led courses and
                hands-on projects.
              </p>
              <Button
                className="skilledition-banner-section-btn"
                onClick={() => navigate("/signin")}
              >
                Get Started <IoArrowForwardOutline />
              </Button>
            </div>

            <div className="skilledition-banner-section-right">
              <img
                src={HomeBanner}
                alt="Dashboard Preview"
                className="skilledition-banner-section-image"
              />
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Course;
